/**
 * Modo mantenimiento de la web: cuando está encendida, TODA la app se reemplaza
 * por la pantalla «Estamos en mantenimiento» (ver `MaintenanceGate`).
 *
 * Booleana simple, apagada por default. Se prende con una regla sin condiciones
 * (nunca por usuario: el visitante anónimo solo trae `anonymous_id`). Si
 * GrowthBook no responde, el flag vale `false` y la app sirve lo normal.
 *
 * Quien opera la migración la prende en GrowthBook y la apaga al terminar; ver
 * el bypass de QA en `lib/maintenanceBypass.ts`.
 */
export const WEB_MAINTENANCE_FLAG = 'web-mantenimiento';

/** Cada cuánto se vuelve a pedir el payload de GrowthBook con la pestaña visible. */
export const MAINTENANCE_REFRESH_INTERVAL_MS = 60_000;

/**
 * Tope de edad del caché local de GrowthBook (localStorage `gbFeaturesCache`).
 * El SDK trae 4 horas: un caché con el flag encendido podría dejar fuera a un
 * usuario horas después de apagarlo si GrowthBook no responde. Con 10 minutos,
 * un caché más viejo se ignora y se pide la red (mismo camino que un visitante
 * nuevo). Afecta a todos los flags, no solo a este.
 */
export const GROWTHBOOK_CACHE_MAX_AGE_MS = 10 * 60_000;
